const testWarningState = {
  hasOverride: false,
  value: null
};

export const setTestEnvironmentWarningForTests = warning => {
  testWarningState.hasOverride = true;
  testWarningState.value = warning;
};

export const resetTestEnvironmentWarningForTests = () => {
  testWarningState.hasOverride = false;
  testWarningState.value = null;
};

export const getAppEnv = () => {
  const raw = process.env.REACT_APP_SENTRY_ENV || process.env.REACT_APP_ENV || "";
  return raw.trim().toLowerCase();
};

export const getTestEnvironmentWarning = () => {
  if (testWarningState.hasOverride) return testWarningState.value;

  const env = getAppEnv();

  if (env === "stage") {
    return {
      env,
      message: "STAGE ENVIRONMENT - NOT PRODUCTION DATA"
    };
  }

  if (env === "sandbox") {
    return {
      env,
      message: "SANDBOX ENVIRONMENT - NOT PRODUCTION DATA"
    };
  }

  return null;
};
